<div class="container">
	<nb-accordion class="accordion-card">
		<nb-accordion-item expanded>
			<nb-accordion-item-header>
				<h1 class="paragraph">DETEKTO MASHTRIMIN</h1>
			</nb-accordion-item-header>
			<nb-accordion-item-body>
				<div class="d-flex">
					<p class="short-paragraph">
						Në këtë uebfaqe, janë paraqitur skenaret e ndryshëm për zbulimin e
						mashtrimit në mënyrë që përdoruesi të ekzaminoj këto të dhëna.
						Ndikimi i inxhierisë, përzgjedhja e veçorive dhe nxjerrja e
						parametrave për hulumtim janë konsideruar me qëllim të arritjes së
						një performance parashikuese sa më të avancuar.
					</p>
					<img src="../../../../../assets/images/scenario.svg" />
				</div>
			</nb-accordion-item-body>
		</nb-accordion-item>
	</nb-accordion>

	<nb-card class="white-card mt-5">
		<p class="paragraph mb-4">
			Aksidentet e përsëritura në periudhën 1 vjeçare
		</p>
		<p class="dark-paragraph">
			Një nga mashtrimet më të zakonshme të aksidenteve të trafikut është i
			njohur kur një automjet i dyshuar papritmas rrëshqet drejt para një makine
			tjetër, e meqenëse është kaq e papritur, shoferi i asaj makine nuk ka kohë
			të mjaftueshme për të reaguar dhe ndaluar makinën. Rezultati është një
			përplasje nga fundi i pasmë. Por nuk ndalet këtu, është e zakonshme që ai
			automjet i dyshimtë të ketë pasagjerë në të.
			<br />
			<br />
			Papritur, këta pasagjerë ankohen për lëndime të dhimbshme të shpinës ose
			qafës. Ata do t'i bëjnë këto pretendime edhe nëse të dy makinat lëviznin
			me shpejtësi të ngadaltë në kohën e përplasjes. Gjëja tjetër që ndodh, si
			shoferi i dyshimtë ashtu edhe pasagjerët e tyre bëjnë pretendime për
			përplasje të mëdha dhe dëmtime dhe kërkojnë kompenzim dëmi pranë kompanisë
			së sigurimeve. <br />
			<br />
			Këto aksidente synohet të përsëriten më shumë se një herë gjatë periudhës
			një vjecare. <br />
			<br />
			Për të kontrolluar nëse aksidenti i plotëson kriteret dhe është rast
			potencial për mashtrim shkruani numrin personal të individit të përfshirë
			në aksident dhe evidentoni gjendjen. <br />
			<br />
			Nëse numri personal i individit është potencial mashtrimi, rekomandohet të
			kontrollohet edhe evidenca e gjendjes nga skenari 3 si më poshtë.
		</p>
	</nb-card>
	<div class="search mb-4">
		<form
			class="form"
			#nameForm="ngForm"
			novalidate
			(ngSubmit)="saveNameForm(personalId)"
		>
			<input
				[(ngModel)]="personalId"
				name="id"
				#id="ngModel"
				placeholder="Kërko numrin personal…"
				nbInput
				aria-describedby="idHelp"
				minlength="10"
				maxlength="10"
			/>
			<button
				id="button"
				type="submit"
				class="blue-button ml-2"
				routerLink="/scenario-one-results/{{ personalId }}"
				[disabled]="id.invalid"
			>
				KËRKO
			</button>
		</form>
		<span
			id="button"
			class="text-danger ml-2 mt-4"
			*ngIf="id && id.invalid && id.touched"
			>Ju lutem shkruani numrin përsonal për të vazhduar</span
		>
	</div>
</div>
